












import Vue from 'vue'

export default Vue.extend({
  name: "UiChip",
  props: {
    img: String,
    isSmall: Boolean,
  }
})
